__turbopack_context__.v({
  "button": "xoiVKa_button",
  "buttonSelected": "xoiVKa_buttonSelected",
  "row": "xoiVKa_row",
});
